export const QUESTION_QUANTITY = 4;
